import { Alert, Platform, StyleSheet, TouchableOpacity, View, useWindowDimensions, Text, Image } from 'react-native'
import React, { useEffect, useState, useCallback } from 'react'
import { FontAwesome } from "@expo/vector-icons";
import i18n from "i18n-js";
import { FormControl, Select, CheckIcon, Modal, ScrollView } from "native-base";
import CustomText from '../components/CustomText';
import Loader from '../components/Loader';
import { connect } from 'react-redux';
import * as actions from "../redux/actions/index"
import { AntDesign, Feather } from '@expo/vector-icons';
import sliceText from "../utils/sliceText"
import { responsiveHeight, responsiveWidth } from 'react-native-responsive-dimensions';
import CreateListing from './CreateListing'
import constants from "../myConfig/constants";
import CustomHeading from '../components/Heading';
import TextInput from "../components/TextInput"
import {image_url} from "../myConfig/api.json"

const COUNT = 8
const THUMB_RADIUS = 12;

function MyListing(props) {
    const { user, garageListing, getGarageListing, deleteListing } = props
    const [loading, setLoading] = useState(true)
    const [modalVisible, setModalVisible] = useState(false)
    const [current, setCurrent] = useState({})
    const [page, setPage] = useState(1)
    const [listing, setListing] = useState([])
    const [selectedList, setSelectedList] = useState([])
    const [deletLoading, setDeleteLoading] = useState(false)
    const { width } = useWindowDimensions()
    const [filterModal, setFilterModal] = useState(false)

    const [fields, setFields] = useState({
        keyword: "",
        category: "",
        subCategory: "",
        subSubCategory: "",
        type: "",
        make: "",
        model: "",
        variant: "",
        city: "",
        sortBy: "",
        priceStart: 1,
        priceEnd: 1000000,
        rating: ""
    })

    function sortData(arr) {
        return arr?.filter(item => {
                return (
                    (fields.keyword === "" || fields.keyword==undefined || item.title?.toLowerCase().includes(fields.keyword?.toLowerCase())) &&
                    (fields.category === "" || fields.category==undefined || item.relation_pivots.categories.includes(parseInt(fields.category))) &&
                    (fields.subCategory === "" || fields.subCategory==undefined || item.relation_pivots.subCategories.includes(parseInt(fields.subCategory))) &&
                    (fields.subSubCategory === "" || fields.subSubCategory==undefined || item.relation_pivots.subSubCategories.includes(parseInt(fields.subSubCategory))) &&
                    (fields.city === "" || fields.city==undefined || item.city.toLowerCase() === fields.city.toLowerCase()) &&
                    (fields.make === "" || fields.make==undefined || item.relation_pivots.makes.includes(parseInt(fields.make))) &&
                    (fields.model === "" || fields.model==undefined || item.relation_pivots.models.includes(parseInt(fields.model))) &&
                    (fields.variant === "" || fields.variant==undefined || item.relation_pivots.variants.includes(parseInt(fields.variant))) &&
                    (parseFloat(item.price) >= parseFloat(fields.priceStart) && parseFloat(item.price) <= parseFloat(fields.priceEnd)) &&
                    (fields.rating === "" || fields.rating==undefined || parseFloat(item.average_ratings) >= parseFloat(fields.rating))
                );
            })
            // .sort((a, b) => {
            //     if (fields.sortBy === "priceAsc") return a.price - b.price;
            //     if (fields.sortBy === "priceDesc") return b.price - a.price;
            //     if (fields.sortBy === "rating") return b.average_ratings - a.average_ratings;
            //     return 0; // Default order
            // });
    }

    useEffect(() => {
        setLoading(true)
        getLisitng()
    }, [])

    useEffect(() => {
        if (garageListing?.listings?.data) {
            setListing(garageListing?.listings?.data)
        }
    }, [garageListing])

    useEffect(() => {
        setLoading(true)
        Promise.all([props.getCategories(), props.getCars()])
            .then(() => setLoading(false))
    }, [])

    useEffect(() => {
        if (fields.category) {
            props.getSubCategories(fields.category)
        }
    }, [fields.category])

    useEffect(() => {
        if (fields.subCategory) {
            props.getSubSubCategories(fields.subCategory)
        }
    }, [fields.subCategory])

    useEffect(() => {
        if (fields.make) {
            props.getTypes(fields.make)
            setFields({ ...fields, type: "", model: "", variant: "" })
            // props.getModels(fields.make)
        }
    }, [fields.make])

    useEffect(() => {
        if (fields.type) {
            console.log("Sdfsadf", fields.make, fields.type)
            props.getModels(fields.make, fields.type)
            setFields({ ...fields, model: "", variant: "" })
        }
    }, [fields.type])

    useEffect(() => {
        if (fields.model) {
            props.getYears(fields.model)
            setFields({ ...fields, variant: "" })
        }
    }, [fields.model])


    function getLisitng() {
        getGarageListing({
            user: user?.garage?.seller?.garage_name
        })
            .then(() => setLoading(false))
    }

    function onDelete(id) {
        Alert.alert(
            'Are you sure?',
            'You want to delete this listing?',
            [
                {
                    text: 'Cancel',
                    style: 'cancel',
                },
                {
                    text: 'Yes',
                    onPress: () => {
                        deleteListing(id).then(() => {
                            getLisitng()
                        })
                    },
                },
            ]
        );
    }

    function onDeleteMult() {
        Alert.alert(
            'Are you sure?',
            'You want to delete this selected listing?',
            [
                {
                    text: 'Cancel',
                    style: 'cancel',
                },
                {
                    text: 'Yes',
                    onPress: () => {
                        setDeleteLoading(true)
                        const promises = selectedList.map(it => deleteListing(it))
                        Promise.all(promises)
                            .then(() => {
                                getLisitng()
                                setDeleteLoading(false)
                                setSelectedList([])
                            })
                            .catch(() => {
                                setDeleteLoading(false)
                            })
                    },
                },
            ]
        );
    }

    const renderThumb = useCallback(() => <View style={styles.root} />, [])
    const renderRailSelected = useCallback(() => <View style={styles.root2} />, [])
    const renderRail = useCallback(() => <View style={styles.root3} />, [])
    const renderNotch = useCallback(() => <View style={styles.root4} />, [])
    const renderLabel = useCallback((value) => (
        <View style={styles.root6}>
            <Text style={styles.text}>{value}</Text>
        </View>
    ), [])

    const handleValueChange = useCallback((low, high) => {
        setFields({ priceStart: low, priceEnd: high });
    }, []);

    function renderSlider() {
        if (Platform.OS == "web") {
            const RangeSliderWeb = require('react-range-slider-input').default
            require('react-range-slider-input/dist/style.css')
            return (
                <RangeSliderWeb min={1} max={1000000} step={1}
                    value={[fields.priceStart, fields.priceEnd]}
                    onInput={(e) => {
                        setFields({ priceStart: e[0], priceEnd: e[1] });
                    }}
                />
            )
        } else {
            const RangeSlider = require('rn-range-slider').default
            return (
                <RangeSlider
                    style={{ marginVertical: 10 }}
                    min={1}
                    max={1000000}
                    step={1}
                    floatingLabel
                    renderThumb={renderThumb}
                    renderRail={renderRail}
                    renderRailSelected={renderRailSelected}
                    renderLabel={renderLabel}
                    renderNotch={renderNotch}
                    onTouchEnd={handleValueChange}
                />
            )
        }
    }

    const renderFilter = () => {
        return (
            <ScrollView contentContainerStyle={{ width: '85%', alignSelf: 'center' }}>
                <TextInput
                    value={fields.keyword}
                    onChangeText={(v) => setFields({ ...fields, keyword: v })}
                    placeholder={i18n.t('S1')}
                    center={true}
                    style={Platform.OS == "web" ? {
                        marginVertical: 5,
                        marginTop: 10,
                        borderColor: 'lightgray',
                        borderWidth: 1,
                    } : {
                        marginVertical: 5,
                        marginTop: 10,
                        borderColor: 'lightgray',
                        borderWidth: 1,
                        shadowColor: "#000",
                        shadowOffset: {
                            width: 0,
                            height: 2,
                        },
                        shadowOpacity: 0.23,
                        shadowRadius: 2.62,
                        backgroundColor: 'white',
                        elevation: 4,
                    }}
                />
                <CustomHeading text={i18n.t('S2')} style={{ marginTop: 7.5, marginBottom: 5, textAlign: i18n.locale == "en" ? "left" : "right" }} />
                <CustomText style={{ marginVertical: 5, textAlign: i18n.locale == "en" ? "left" : "right" }} text={i18n.t('DASH_TEXT1')} />
                <FormControl>
                    <Select
                        selectedValue={Number(fields.category)}
                        onValueChange={(v) => setFields({ ...fields, category: v })}
                        accessibilityLabel={i18n.t('S3')}
                        placeholder={i18n.t('S3')}
                        placeholderTextColor={"black"}
                        // fontWeight="bold"
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }}
                        fontFamily={i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold"}
                        marginY={0.35}
                        fontSize={14}
                        borderRadius={30}
                        backgroundColor="white"
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        {props.categories.map((item) => (
                            <Select.Item
                                _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }}
                                style={{ fontFamily: "Poppins-Regular" }}
                                key={item.id}
                                label={i18n.locale == "en" ? item.title : item.ar_title}
                                value={item.id}
                            />
                        ))}
                    </Select>
                </FormControl>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <View style={{ width: '45%' }}>
                        <FormControl>
                            <Select
                                isDisabled={!fields.category}
                                selectedValue={Number(fields.subCategory)}
                                onValueChange={(v) => setFields({ ...fields, subCategory: v })}
                                accessibilityLabel={i18n.t('S5')}
                                placeholder={i18n.t('S5')}
                                placeholderTextColor={"black"}
                                fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                textAlign={i18n.locale == "en" ? "left" : "right"}
                                style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                marginY={0.35}
                                fontSize={14}
                                borderRadius={30}
                                backgroundColor="white"
                                height={39.9}
                                shadow={Platform.OS == "web" ? "none" : "1"}
                                _selectedItem={{
                                    bg: "teal.600",
                                    endIcon: <CheckIcon size={5}
                                    />
                                }}>
                                {props.subCategories.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                            </Select>
                        </FormControl>
                    </View>
                    <View style={{ width: '45%' }}>
                        <FormControl>
                            <Select
                                isDisabled={!fields.subCategory}
                                selectedValue={Number(fields.subSubCategory)}
                                onValueChange={(v) => setFields({ ...fields, subSubCategory: v })}
                                accessibilityLabel={i18n.t('S6')}
                                placeholder={i18n.t('S6')}
                                placeholderTextColor={"black"}
                                fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                textAlign={i18n.locale == "en" ? "left" : "right"}
                                style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                marginY={0.35}
                                fontSize={14}
                                borderRadius={30}
                                backgroundColor="white"
                                height={39.9}
                                shadow={Platform.OS == "web" ? "none" : "1"}
                                _selectedItem={{
                                    bg: "teal.600",
                                    endIcon: <CheckIcon size={5}
                                    />
                                }}>
                                {props.subSubCategories.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                            </Select>
                        </FormControl>
                    </View>
                </View>
                <CustomText style={{ marginVertical: 5, textAlign: i18n.locale == "en" ? "left" : "right" }} text={i18n.t('S11')} />
                <FormControl>
                    <Select
                        selectedValue={Number(fields.make)}
                        onValueChange={(v) => setFields({ ...fields, make: v })}
                        accessibilityLabel={i18n.t('S12')}
                        placeholder={i18n.t('S12')}
                        placeholderTextColor={"black"}
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }}
                        marginY={0.35}
                        fontSize={14}
                        fontFamily={i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold"}
                        borderRadius={30}
                        backgroundColor="white"
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        {props.cars.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                    </Select>
                </FormControl>
                <FormControl>
                    <Select
                        isDisabled={!(fields.make)}
                        selectedValue={Number(fields.type)}
                        onValueChange={(v) => setFields({ ...fields, type: v })}
                        accessibilityLabel={i18n.t('CAR_D_TYPE')}
                        placeholder={i18n.t('CAR_D_TYPE')}
                        placeholderTextColor={"black"}
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                        fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                        marginY={0.35}
                        fontSize={14}
                        borderRadius={30}
                        backgroundColor="white"
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        {props.types.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                    </Select>
                </FormControl>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <View style={{ width: '45%' }}>
                        <FormControl>
                            <Select
                                isDisabled={!(fields.type)}
                                selectedValue={Number(fields.model)}
                                onValueChange={(v) => setFields({ ...fields, model: v })}
                                accessibilityLabel={i18n.t('S5')}
                                placeholder={i18n.t('S5')}
                                placeholderTextColor={"black"}
                                textAlign={i18n.locale == "en" ? "left" : "right"}
                                fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                marginY={0.35}
                                fontSize={14}
                                borderRadius={30}
                                backgroundColor="white"
                                height={39.9}
                                shadow={Platform.OS == "web" ? "none" : "1"}
                                _selectedItem={{
                                    bg: "teal.600",
                                    endIcon: <CheckIcon size={5}
                                    />
                                }}>
                                {props.models.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                            </Select>
                        </FormControl>
                    </View>
                    <View style={{ width: '45%' }}>
                        <FormControl>
                            <Select
                                isDisabled={!fields.model}
                                selectedValue={Number(fields.variant)}
                                onValueChange={(v) => setFields({ ...fields, variant: v })}
                                accessibilityLabel={i18n.t('S6')}
                                placeholder={i18n.t('S6')}
                                placeholderTextColor={"black"}
                                textAlign={i18n.locale == "en" ? "left" : "right"}
                                fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                marginY={0.35}
                                fontSize={14}
                                borderRadius={30}
                                backgroundColor="white"
                                height={39.9}
                                shadow={Platform.OS == "web" ? "none" : "1"}
                                _selectedItem={{
                                    bg: "teal.600",
                                    endIcon: <CheckIcon size={5}
                                    />
                                }}>
                                {props.years.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                            </Select>
                        </FormControl>
                    </View>
                </View>
                <CustomText style={{ marginVertical: 5, textAlign: i18n.locale == "en" ? "left" : "right" }} text={i18n.t('S13')} />
                <FormControl>
                    <Select
                        selectedValue={fields.city}
                        onValueChange={(v) => setFields({ ...fields, city: v })}
                        accessibilityLabel={i18n.t('S3')}
                        placeholder={i18n.t('S14')}
                        placeholderTextColor={"black"}
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }}
                        fontFamily={i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold"}
                        marginY={0.35}
                        fontSize={14}
                        borderRadius={30}
                        backgroundColor="white"
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY1')} label={i18n.t('CITY1')} value={"Abu Dhabi"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY2')} label={i18n.t('CITY2')} value={"Al Ain"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY3')} label={i18n.t('CITY3')} value={"Ajman"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY4')} label={i18n.t('CITY4')} value={"Dubai"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY5')} label={i18n.t('CITY5')} value={"Fujairah"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY6')} label={i18n.t('CITY6')} value={"Sharjah"} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('CITY7')} label={i18n.t('CITY7')} value={"Ras Al Khaimah"} />
                    </Select>
                </FormControl>
                <FormControl>
                    <Select
                        selectedValue={fields.sortBy}
                        onValueChange={(v) => setFields({ ...fields, sortBy: v })}
                        accessibilityLabel={i18n.t('S15')}
                        placeholder={i18n.t('S15')}
                        placeholderTextColor={"black"}
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }}
                        fontFamily={i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold"}
                        marginY={0.35}
                        fontSize={14}
                        borderRadius={30}
                        backgroundColor="white"
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('S18')} label={i18n.t('S18')} value="Oldest" />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={i18n.t('S19')} label={i18n.t('S19')} value="Newest" />

                    </Select>
                </FormControl>
                <View
                    style={Platform.OS == "web" ? {
                        padding: 10,
                        marginVertical: 2,
                        backgroundColor: 'white',
                        borderRadius: 20,
                        borderColor: 'lightgray',
                        borderWidth: 1
                    } : {
                        padding: 10,
                        marginVertical: 2,
                        backgroundColor: 'white',
                        borderRadius: 20,
                        borderColor: 'lightgray',
                        borderWidth: 1,
                        shadowColor: "#000",
                        shadowOffset: {
                            width: 0,
                            height: 2,
                        },
                        shadowOpacity: 0.23,
                        shadowRadius: 2.62,

                        elevation: 4,
                    }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                        <View><CustomText text={i18n.t('S10')} /></View>
                        <View>
                            <CustomText style={{ color: "gray" }} text={`AED  ${fields.priceStart} - AED  ${fields.priceEnd}`} />
                        </View>
                    </View>
                    {renderSlider()}
                </View>
                <FormControl>
                    <Select
                        selectedValue={fields.rating}
                        onValueChange={(v) => setFields({ ...fields, rating: v })}
                        accessibilityLabel={i18n.t('VIEW_LIST_TEXT5')}
                        placeholder={i18n.t('VIEW_LIST_TEXT5')}
                        placeholderTextColor={"black"}
                        textAlign={i18n.locale == "en" ? "left" : "right"}
                        style={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }}
                        marginY={0.35}
                        fontSize={14}
                        borderRadius={30}
                        backgroundColor="white"
                        fontFamily={i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold"}
                        height={39.9}
                        shadow={Platform.OS == "web" ? "none" : "1"}
                        _selectedItem={{
                            bg: "teal.600",
                            endIcon: <CheckIcon size={5}
                            />
                        }}>
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={5.0} label={"5.0"} value={5.0} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={4.5} label={"4.5"} value={4.5} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={4.0} label={"4.0"} value={4.0} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={3.5} label={"3.5"} value={3.5} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={3.0} label={"3.0"} value={3.0} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={2.5} label={"2.5"} value={2.5} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={2.0} label={"2.0"} value={2.0} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={1.5} label={"1.5"} value={1.5} />
                        <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Medium" : "GE-SS-Unique-Bold" }} key={1.0} label={"1.0"} value={1.0} />

                    </Select>
                </FormControl>
                <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginVertical: 10 }}>
                    <TouchableOpacity
                        onPress={() => {
                            setFields({
                                keyword: "",
                                category: "",
                                subCategory: "",
                                subSubCategory: "",
                                type: "",
                                make: "",
                                model: "",
                                variant: "",
                                city: "",
                                sortBy: "",
                                priceStart: 1,
                                priceEnd: 10000,
                                rating: ""
                            })
                        }}
                        style={{
                            backgroundColor: 'white',
                            width: 95,
                            height: 35,
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 20,
                            borderWidth: 1,
                            borderColor: 'lightgray',
                            shadowColor: "#000",
                            shadowOffset: {
                                width: 0,
                                height: 2,
                            },
                            shadowOpacity: 0.23,
                            shadowRadius: 2.62,
                            elevation: 4,
                        }}
                    >
                        <CustomText style={{ color: 'lightgray', textAlign: 'center' }} text={i18n.t('S16')} />
                    </TouchableOpacity>
                    <TouchableOpacity
                        onPress={() => {
                            setFilterModal(false)
                        }}
                        style={{
                            backgroundColor: 'black',
                            width: 170,
                            height: 35,
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 20,
                            borderWidth: 1,
                            borderColor: 'black',
                            shadowColor: "#000",
                            shadowOffset: {
                                width: 0,
                                height: 2,
                            },
                            shadowOpacity: 0.23,
                            shadowRadius: 2.62,
                            elevation: 4,
                        }}
                    >
                        <CustomText style={{ color: 'white', textAlign: 'center' }} text={i18n.t('SE1')} />
                    </TouchableOpacity>
                </View>
            </ScrollView>
        )
    }

    if (loading) {
        return <Loader />
    }

    return (
        <View style={{ flex: 1 }}>
            <View style={{ width: '90%', alignSelf: 'center' }}>
                <ScrollView contentContainerStyle={{ flexGrow: 1, paddingTop: 20, paddingBottom: 20, alignSelf: 'center' }} horizontal={true} showsHorizontalScrollIndicator={false}>
                    <View style={{ flexDirection: 'row', marginTop: 10 }}>

                        <TouchableOpacity
                            onPress={() => setFilterModal(true)}
                            style={{
                                height: 40,
                                width: 40,
                                borderRadius: 20,
                                backgroundColor: 'white',
                                marginHorizontal: 5,
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderColor: 'lightgray',
                                borderWidth: 1,
                                shadowColor: "#000",
                                shadowOffset: {
                                    width: 0,
                                    height: 2,
                                },
                                shadowOpacity: 0.23,
                                shadowRadius: 2.62,

                                elevation: 4,
                            }}>
                            <FontAwesome name="filter" size={24} color="black" />
                        </TouchableOpacity>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    selectedValue={Number(fields.category)}
                                    onValueChange={(v) => setFields({ ...fields, category: v })}
                                    accessibilityLabel={i18n.t('S3')}
                                    placeholder={i18n.t('S3')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    minWidth={160}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.categories.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    isDisabled={!fields.category}
                                    selectedValue={Number(fields.subCategory)}
                                    onValueChange={(v) => setFields({ ...fields, subCategory: v })}
                                    accessibilityLabel={i18n.t('S5')}
                                    placeholder={i18n.t('S5')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    minWidth={90}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.subCategories.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    isDisabled={!fields.subCategory}
                                    selectedValue={Number(fields.subSubCategory)}
                                    onValueChange={(v) => setFields({ ...fields, subSubCategory: v })}
                                    accessibilityLabel={i18n.t('S6')}
                                    placeholder={i18n.t('S6')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    minWidth={120}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.subSubCategories.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    selectedValue={Number(fields.make)}
                                    onValueChange={(v) => setFields({ ...fields, make: v })}
                                    accessibilityLabel={i18n.t('S12')}
                                    placeholder={i18n.t('S12')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    minWidth={100}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.cars.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    isDisabled={!fields.make}
                                    selectedValue={Number(fields.type)}
                                    onValueChange={(v) => setFields({ ...fields, type: v })}
                                    accessibilityLabel={i18n.t('CAR_D_TYPE')}
                                    placeholder={i18n.t('CAR_D_TYPE')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    backgroundColor="white"
                                    minWidth={100}
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.types.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    isDisabled={!fields.type}
                                    selectedValue={Number(fields.model)}
                                    onValueChange={(v) => setFields({ ...fields, model: v })}
                                    accessibilityLabel={i18n.t('S5')}
                                    placeholder={i18n.t('S5')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    minWidth={90}
                                    borderRadius={30}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.models.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>


                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    isDisabled={!fields.model}
                                    selectedValue={Number(fields.variant)}
                                    onValueChange={(v) => setFields({ ...fields, variant: v })}
                                    accessibilityLabel={i18n.t('S6')}
                                    placeholder={i18n.t('S6')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    minWidth={120}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    {props.years.map((item) => <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={item.id} label={i18n.locale == "en" ? item.title : item.ar_title} value={item.id} />)}
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    selectedValue={fields.city}
                                    onValueChange={(v) => setFields({ ...fields, city: v })}
                                    accessibilityLabel={i18n.t('S3')}
                                    placeholder={i18n.t('S14')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    backgroundColor="white"
                                    height={39.9}
                                    minWidth={90}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY1')} label={i18n.t('CITY1')} value='Abu Dhabi' />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY2')} label={i18n.t('CITY2')} value="Al Ain" />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY3')} label={i18n.t('CITY3')} value="Ajman" />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY4')} label={i18n.t('CITY4')} value="Dubai" />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY5')} label={i18n.t('CITY5')} value="Fujairah" />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY6')} label={i18n.t('CITY6')} value="Sharjah" />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('CITY7')} label={i18n.t('CITY7')} value="Ras Al Khaimah" />
                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    selectedValue={fields.sortBy}
                                    onValueChange={(v) => setFields({ ...fields, sortBy: v })}
                                    accessibilityLabel={i18n.t('S15')}
                                    placeholder={i18n.t('S15')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    minWidth={110}
                                    fontSize={14}
                                    borderRadius={30}
                                    backgroundColor="white"
                                    height={39.9}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('S18')} label={i18n.t('S18')} value='Oldest' />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={i18n.t('S19')} label={i18n.t('S19')} value='Newest' />

                                </Select>
                            </FormControl>
                        </View>

                        <View style={{ marginHorizontal: 5 }}>
                            <FormControl>
                                <Select
                                    selectedValue={fields.rating}
                                    onValueChange={(v) => {
                                        setFields({ ...fields, rating: v })
                                    }}
                                    accessibilityLabel={i18n.t('VIEW_LIST_TEXT5')}
                                    placeholder={i18n.t('VIEW_LIST_TEXT5')}
                                    placeholderTextColor={"black"}
                                    style={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light' }}
                                    fontFamily={i18n.locale == "en" ? "Poppins-Regular" : 'GE-SS-Unique-Light'}
                                    marginY={0.35}
                                    fontSize={14}
                                    borderRadius={30}
                                    backgroundColor="white"
                                    height={39.9}
                                    minWidth={100}
                                    shadow={Platform.OS == "web" ? "none" : "1"}
                                    _selectedItem={{
                                        bg: "teal.600",
                                        endIcon: <CheckIcon size={5}
                                        />
                                    }}>
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={5.0} label={"5.0"} value={5.0} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={4.5} label={"4.5"} value={4.5} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={4.0} label={"4.0"} value={4.0} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={3.5} label={"3.5"} value={3.5} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={3.0} label={"3.0"} value={3.0} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={2.5} label={"2.5"} value={2.5} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={2.0} label={"2.0"} value={2.0} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={1.5} label={"1.5"} value={1.5} />
                                    <Select.Item _text={{ fontFamily: i18n.locale == "en" ? "Poppins-Regular" : "GE-SS-Unique-Light" }} key={1.0} label={"1.0"} value={1.0} />

                                </Select>
                            </FormControl>
                        </View>
                    </View>
                </ScrollView>
            </View>
            <View style={{ width: '90%', alignSelf: 'center', flex: 1 }}>
                <View style={{ flex: 1 }}>
                    <View>
                        {
                            sortData(garageListing?.listings?.data)?.length > 0 ? (
                                <ScrollView horizontal={true}>
                                    <View>
                                        <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: 'lightgray', paddingHorizontal: 5, paddingVertical: 5, marginTop: 10, borderRadius: 5 }}>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 50 : responsiveWidth(8) }}>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        setSelectedList(sortData(garageListing?.listings?.data).slice((page - 1) * COUNT, ((page - 1) * COUNT) + COUNT).map(item => item?.id))
                                                    }}
                                                >
                                                    <View style={{ width: 12, height: 12, backgroundColor: 'white', borderRadius: 2, justifyContent: 'center', alignItems: 'center' }}>
                                                        {selectedList.length == sortData(garageListing?.listings?.data).slice((page - 1) * COUNT, ((page - 1) * COUNT) + COUNT).length && <AntDesign name='check' size={9} />}
                                                    </View>
                                                </TouchableOpacity>
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 100 : responsiveWidth(10) }}>
                                                <CustomText text={i18n.t('NUM')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(15) }}>
                                                <CustomText text={i18n.t('PRICE')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? (width - 700 - constants.DRAWER_WIDTH - (((width - constants.DRAWER_WIDTH) * 0.1))) : responsiveWidth(35) }}>
                                                <CustomText text={i18n.t('LISTING_TITLE')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20) }}>
                                                <CustomText text={i18n.t('CITY')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20) }}>
                                                <CustomText text={i18n.t('STATUS')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20) }}>
                                                <CustomText text={i18n.t('IMAGE')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(25) }}>
                                                <CustomText text={i18n.t('CREATED_DATE')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                            <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 100 : responsiveWidth(15) }}>
                                                <CustomText text={i18n.t('ACTIONS')} style={{ fontSize: Platform.OS=="web"?13:11, }} />
                                            </View>
                                        </View>
                                        {
                                            sortData(garageListing?.listings?.data).slice((page - 1) * COUNT, ((page - 1) * COUNT) + COUNT)?.map((it, i) => {
                                                const selected = selectedList.find(item => item == it?.id)
                                                return (
                                                    <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: 'white', paddingHorizontal: 5, paddingVertical: 10, marginTop: 2, borderRadius: 5 }}>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 50 : responsiveWidth(8) }}>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    if (!selected) {
                                                                        setSelectedList([...selectedList, it?.id])
                                                                    } else {
                                                                        setSelectedList(selectedList.filter(item => item != selected))
                                                                    }
                                                                }}
                                                                hitSlop={3}
                                                            >
                                                                <View style={{ width: 12, height: 12, backgroundColor: 'lightgray', borderRadius: 2, justifyContent: 'center', alignItems: 'center' }}>
                                                                    {selected && <AntDesign name='check' size={9} />}
                                                                </View>
                                                            </TouchableOpacity>
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 100 : responsiveWidth(10) }}>
                                                            <CustomText text={i + 1} style={{ fontSize: Platform.OS=="web"?12:9.5, marginLeft: 8 }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(15) }}>
                                                            <CustomText text={it?.price + " AED"} style={{ fontSize: Platform.OS=="web"?12:9.5, }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? (width - 700 - constants.DRAWER_WIDTH - (((width - constants.DRAWER_WIDTH) * 0.1))) : responsiveWidth(35) }}>
                                                            <CustomText text={sliceText(i18n.locale == "en" ? it?.title : it?.ar_title, 20)} style={{ fontSize: Platform.OS=="web"?12:9.5, }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20) }}>
                                                            <CustomText text={sliceText(i18n.locale == "en" ? it?.city : it?.city, 20)} style={{ fontSize: Platform.OS=="web"?12:9.5, }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20) }}>
                                                            <CustomText text={sliceText(it?.status, 20)} style={{ fontSize: Platform.OS=="web"?12:9.5, }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(20),alignItems:i18n.locale == "en" ?"flex-start":"flex-end" }}>
                                                            {it?.images?.length>0 ? <Image resizeMode="contain" style={{width:30,height:20}} source={{uri:`${image_url}/listings/${it?.images[0].name}`}}/>:null}
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 150 : responsiveWidth(25) }}>
                                                            <CustomText text={it?.create_date} style={{ fontSize: Platform.OS=="web"?12:9.5, }} />
                                                        </View>
                                                        <View style={{ width: Platform.OS == "web" && width > constants.BREAK_POINT_1 ? 100 : responsiveWidth(15), flexDirection: 'row', justifyContent: i18n.locale == "en" ? 'flex-start' : 'flex-end' }}>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    setCurrent(it)
                                                                    setModalVisible(true)
                                                                }}
                                                            >
                                                                <Feather name="edit" size={15} color={"#fcce00"} />
                                                            </TouchableOpacity>
                                                            <TouchableOpacity
                                                                onPress={() => onDelete(it?.id)}
                                                                style={{ marginLeft: 10 }}>
                                                                <AntDesign name="delete" size={15} color={"red"} />
                                                            </TouchableOpacity>
                                                        </View>
                                                    </View>
                                                )
                                            })
                                        }
                                    </View>
                                </ScrollView>
                            ) : (
                                <CustomText text={i18n.t('NO_LISTING_FOUND')} style={{ textAlign: 'center', marginTop: 10 }} />
                            )
                        }
                    </View>
                    {
                        listing?.length > 0 && (
                            <ScrollView>
                                <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10, justifyContent: 'center' }}>
                                    <TouchableOpacity
                                        onPress={() => {
                                            if (page != 1) {
                                                setPage(page - 1)
                                            }
                                        }}
                                    >
                                        <View style={{ width: 35, height: 35, borderRadius: 35, backgroundColor: 'lightgray', justifyContent: 'center', alignItems: 'center' }}>
                                            <AntDesign name={"left"} color={"gray"} size={15} />
                                        </View>
                                    </TouchableOpacity>
                                    {Array.from({ length: Math.ceil((listing.length / COUNT)) }).map((it, i) => {
                                        return (
                                            <TouchableOpacity
                                                onPress={() => setPage(i + 1)}
                                            >
                                                <View style={{ width: 35, height: 35, borderRadius: 35, backgroundColor: (page == i + 1) ? "white" : 'lightgray', justifyContent: 'center', alignItems: 'center', marginLeft: 6 }}>
                                                    <CustomText text={i + 1} style={{ color: 'gray', textAlign: 'center' }} />
                                                </View>
                                            </TouchableOpacity>
                                        )
                                    })}
                                    <TouchableOpacity
                                        onPress={() => {
                                            if (page != Math.ceil((listing.length / COUNT))) {
                                                setPage(page + 1)
                                            }
                                        }}
                                    >
                                        <View style={{ width: 35, height: 35, borderRadius: 35, backgroundColor: 'lightgray', justifyContent: 'center', alignItems: 'center', marginLeft: 6 }}>
                                            <AntDesign name={"right"} color={"gray"} size={15} />
                                        </View>
                                    </TouchableOpacity>
                                    {
                                        selectedList?.length > 0 && (
                                            <View style={{ position: 'absolute', right: 10 }}>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        onDeleteMult()
                                                    }}
                                                    style={{ padding: 5, paddingVertical: 8, borderRadius: 20, backgroundColor: '#e3e3e4', width: 90, marginLeft: 5, borderWidth: 1, borderColor: 'lightgray' }}>
                                                    <CustomText text={i18n.t('PROFILE_BTN1') + (deletLoading ? `...` : ` (${selectedList.length})`)} style={{ textAlign: 'center', fontSize: 10 }} />
                                                </TouchableOpacity>
                                            </View>
                                        )
                                    }
                                </View>
                            </ScrollView>
                        )
                    }
                </View>
            </View>
            {modalVisible && (
                <Modal isOpen={modalVisible} onClose={() => setModalVisible(false)} size={"full"}>
                    <Modal.Content minH={"xl"} style={{ borderRadius: 25 }}>
                        <TouchableOpacity onPress={() => setModalVisible(false)} style={{ position: 'absolute', top: 15, right: 15, zIndex: 2 }}>
                            <AntDesign name='close' size={25} color={"gray"} />
                        </TouchableOpacity>
                        <Modal.Body>
                            <ScrollView>
                                <CreateListing update={current} cb={() => setModalVisible(false)} getLisitng={getLisitng} />
                            </ScrollView>
                        </Modal.Body>
                    </Modal.Content>
                </Modal>
            )}
            {
                filterModal && (
                    <Modal isOpen={filterModal} onClose={() => setFilterModal(false)} size={"full"}>
                        <Modal.Content minH={responsiveHeight(90)} style={{ borderRadius: 25 }}>
                            {/* <TouchableOpacity onPress={() => setFilterModal(false)} style={{ position: 'absolute', top: 15, right: 15, zIndex: 2 }}>
                                <AntDesign name='close' size={25} color={"gray"} />
                            </TouchableOpacity> */}
                            <Modal.Body>
                                <ScrollView>
                                    {renderFilter()}
                                </ScrollView>
                            </Modal.Body>
                        </Modal.Content>
                    </Modal>
                )
            }
        </View >
    )
}

function mapStateToProps({ user, garageListing, categories, subCategories, subSubCategories, types, cars, models, years, }) {
    return { user, garageListing, categories, subCategories, subSubCategories, types, cars, models, years, }
}
export default connect(mapStateToProps, actions)(MyListing)
const styles = StyleSheet.create({
    root: {
        width: THUMB_RADIUS * 2,
        height: THUMB_RADIUS * 2,
        borderRadius: THUMB_RADIUS,
        borderWidth: 2,
        borderColor: "#B9C7DB",
        backgroundColor: '#B9C7DB',
    },
    root2: {
        height: 4,
        backgroundColor: '#B9C7DB',
        borderRadius: 2,
    },
    root3: {
        flex: 1,
        height: 4,
        borderRadius: 2,
        backgroundColor: '#7f7f7f',
    },
    root4: {
        width: 8,
        height: 8,
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        borderTopColor: '#B9C7DB',
        borderLeftWidth: 4,
        borderRightWidth: 4,
        borderTopWidth: 8,
    },
    root5: {
        alignItems: 'center',
        padding: 8,
        backgroundColor: '#4499ff',
        borderRadius: 4,
    },
    text5: {
        fontSize: 16,
        color: '#fff',
    },
    root6: {
        alignItems: 'center',
        padding: 8,
        backgroundColor: '#B9C7DB',
        borderRadius: 4,
    },
})